import { render, staticRenderFns } from "./footerNav.vue?vue&type=template&id=8341504e&scoped=true&"
import script from "./footerNav.vue?vue&type=script&lang=js&"
export * from "./footerNav.vue?vue&type=script&lang=js&"
import style0 from "./footerNav.vue?vue&type=style&index=0&id=8341504e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8341504e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/show/footerNav.vue
// module id = null
// module chunks = 